'use client';

import { Button } from '@zillow/constellation-10';
import { Phone } from 'lucide-react';
import { useTranslations } from 'next-intl';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { LucideIcon } from '@/src/components/LucideIcon';
import { emitTrackPhoneLeadEvent } from '@/src/components/features/property/lib/analytics';
import { footerActions } from './propertyManagerModule.styles';

type Props = {
  listing: PropertyDetailListing;
};

export const PropertyManagerFooter = ({ listing }: Props) => {
  const t = useTranslations('hdp');
  const contactPhone = listing?.listedBy?.contactPhone;

  if (!listing || listing.active === false || !contactPhone) return null;

  const handleCall = () => {
    emitTrackPhoneLeadEvent({ listing });
    window.location.href = `tel:${contactPhone.replace(/\D/g, '')}`;
  };

  return (
    <div className={footerActions}>
      <Button
        tone="brand"
        emphasis="outlined"
        fluid={true}
        icon={<LucideIcon icon={Phone} size="sm" />}
        onClick={handleCall}
        data-testid="button-call"
      >
        {t('callCta')}
      </Button>
    </div>
  );
};
